module.exports = __webpack_public_path__ + "img/Group.436f5919.svg";